<template>
  <div >
    
     

    <DoughnutChart
      :chart-data="datacollection"
    ></DoughnutChart>
  
  </div>
</template>

<script>
  /* eslint-disable */
  import DoughnutChart from './DoughnutChart'
  

  export default {
    components: {
      DoughnutChart
    },
    data () {
      return {
        datacollection: null,
        data_inchart : [12,34,23],
       }
    },
     mounted () {
      

      this.fillData()

    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: ['PCV','BUN','CRETINENE'],
          datasets: [
            {
              label: ['PCV','BUN','CRETINENE'],
              backgroundColor: ['rgba(0,51,255,0.6)','rgba(102,204,102,0.4)','rgba(204,0,102,0.2)'],
              borderColor: 'lightblue', 
              data: this.data_inchart 
            } 
          ]
        }
      }
      ,
        getRandomInt () {
          return Math.floor(Math.random() * (50 - 5 + 1)) + 5
        }
      ,  
       
    
      
      
    }
  }
</script>

<style>
  .small {
    width: 500px;
    height: 100px;
    margin: auto
  }
</style>